import axios from '../../../build/http-requests/axios-common'

export default {
  state: {
  },

  mutations: {
  },

  actions: {
    searchOccurrenceReport: ({ commit }, filter) => {
      return new Promise((resolve, reject) => {
        axios.post('/occurrenceReport/searchOccurrenceReport', filter).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },

  getters: {
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/occurrenceReport.js